import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store';
import { useBlocklistApi } from '../api';
import { resetError, setError, setLoading } from '../slices';
import { CreateBlocklistItemRequestData, UpdateBlocklistItemRequestData } from '../types';

export const useBlocklistService = () => {
  const dispatch = useDispatch();
  const { loading, error } = useAppSelector(state => state.blocklist);

  const api = useBlocklistApi();

  const createBlocklistItem = useCallback(async (data: CreateBlocklistItemRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ create: true }));

      await api.createBlocklistItem(data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ create: false }));
    }
  }, []);

  const updateBlocklistItem = useCallback(
    async (itemId: string, data: UpdateBlocklistItemRequestData) => {
      try {
        dispatch(resetError());
        dispatch(setLoading({ update: true }));

        await api.updateBlocklistItem(itemId, data);
      } catch (e) {
        dispatch(setError(e));
        throw e;
      } finally {
        dispatch(setLoading({ update: false }));
      }
    },
    [],
  );

  const deleteBlocklistItem = useCallback(async (itemId: string) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ delete: true }));

      await api.deleteBlocklistItem(itemId);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ delete: false }));
    }
  }, []);

  return {
    loading,
    error,
    createBlocklistItem,
    updateBlocklistItem,
    deleteBlocklistItem,
  };
};
